import _definePage_default_0 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/admin/issue-cases/index.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/admin/jobs/index.vue?definePage&vue'
import _definePage_default_3 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/admin/review-api-users/index.vue?definePage&vue'
import _definePage_default_4 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/admin/review-images/index.vue?definePage&vue'
import _definePage_default_5 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/admin/xls-files/index.vue?definePage&vue'
import _definePage_default_6 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/campaigns/cdn-campaign-url.vue?definePage&vue'
import _definePage_default_7 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/hr/leave/index.vue?definePage&vue'
import _definePage_default_8 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/hyper-speed/index.vue?definePage&vue'
import _definePage_default_9 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/login.vue?definePage&vue'
import _definePage_default_10 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/oauth/login.vue?definePage&vue'
import _definePage_default_11 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/regle/dashboard.vue?definePage&vue'
import _definePage_default_12 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/regle/email-templates/index.vue?definePage&vue'
import _definePage_default_13 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/regle/email-templates/[id].vue?definePage&vue'
import _definePage_default_14 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/regle/notification-logs/index.vue?definePage&vue'
import _definePage_default_15 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/regle/notification-settings/index.vue?definePage&vue'
import _definePage_default_16 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/auto-migration/index.vue?definePage&vue'
import _definePage_default_17 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/auto-migration-list/index.vue?definePage&vue'
import _definePage_default_18 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/channels/index.vue?definePage&vue'
import _definePage_default_19 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/client/index.vue?definePage&vue'
import _definePage_default_20 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/client/[id]/index.vue?definePage&vue'
import _definePage_default_21 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/client/[id]/edit.vue?definePage&vue'
import _definePage_default_22 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/client/create.vue?definePage&vue'
import _definePage_default_23 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/client-reports/index.vue?definePage&vue'
import _definePage_default_24 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/crawling-status/index.vue?definePage&vue'
import _definePage_default_25 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/crema-brands/index.vue?definePage&vue'
import _definePage_default_26 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/daily-reports/index.vue?definePage&vue'
import _definePage_default_27 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/data/index.vue?definePage&vue'
import _definePage_default_28 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/download-driver/index.vue?definePage&vue'
import _definePage_default_29 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/error-stats/index.vue?definePage&vue'
import _definePage_default_30 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/estimates/index.vue?definePage&vue'
import _definePage_default_31 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/estimates/create.vue?definePage&vue'
import _definePage_default_32 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/image-size/index.vue?definePage&vue'
import _definePage_default_33 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/mapping-manager/index.vue?definePage&vue'
import _definePage_default_34 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/naver-xls/index.vue?definePage&vue'
import _definePage_default_35 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/non-displayed-items/index.vue?definePage&vue'
import _definePage_default_36 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/report/index.vue?definePage&vue'
import _definePage_default_37 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/scan/index.vue?definePage&vue'
import _definePage_default_38 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/scanner/index.vue?definePage&vue'
import _definePage_default_39 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/tasks/index.vue?definePage&vue'
import _definePage_default_40 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/upload/index.vue?definePage&vue'
import _definePage_default_41 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/upload-driver/index.vue?definePage&vue'
import _definePage_default_42 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/upload-summary/index.vue?definePage&vue'
import _definePage_default_43 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/settings/mcp-api-keys/index.vue?definePage&vue'
import _definePage_default_44 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/settings/oauth-clients/index.vue?definePage&vue'
import _definePage_default_45 from '/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/utility/index.vue?definePage&vue'

export const routes = [
  {
    path: '/admin',
    /* internal name: 'admin' */
    /* no component */
    children: [
      {
        path: 'issue-cases',
        /* internal name: 'admin-issue-cases' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-issue-cases',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/admin/issue-cases/index.vue'),
            /* no children */
          },
  _definePage_default_0
  )
        ],
      },
      {
        path: 'jobs',
        /* internal name: 'admin-jobs' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-jobs',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/admin/jobs/index.vue'),
            /* no children */
          },
  _definePage_default_2
  )
        ],
      },
      {
        path: 'review-api-users',
        /* internal name: 'admin-review-api-users' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-review-api-users',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/admin/review-api-users/index.vue'),
            /* no children */
          },
  _definePage_default_3
  )
        ],
      },
      {
        path: 'review-images',
        /* internal name: 'admin-review-images' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-review-images',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/admin/review-images/index.vue'),
            /* no children */
          },
  _definePage_default_4
  )
        ],
      },
      {
        path: 'xls-files',
        /* internal name: 'admin-xls-files' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-xls-files',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/admin/xls-files/index.vue'),
            /* no children */
          },
  _definePage_default_5
  )
        ],
      }
    ],
  },
  {
    path: '/campaigns',
    /* internal name: 'campaigns' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'cdn-campaign-url',
        name: 'campaigns-cdn-campaign-url',
        component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/campaigns/cdn-campaign-url.vue'),
        /* no children */
      },
  _definePage_default_6
  )
    ],
  },
  {
    path: '/hr',
    /* internal name: 'hr' */
    /* no component */
    children: [
      {
        path: 'leave',
        /* internal name: 'hr-leave' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'hr-leave',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/hr/leave/index.vue'),
            /* no children */
          },
  _definePage_default_7
  )
        ],
      }
    ],
  },
  {
    path: '/hyper-speed',
    /* internal name: 'hyper-speed' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'hyper-speed',
        component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/hyper-speed/index.vue'),
        /* no children */
      },
  _definePage_default_8
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/login.vue'),
    /* no children */
  },
  _definePage_default_9
  ),
  {
    path: '/oauth',
    /* internal name: 'oauth' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'login',
        name: 'oauth-login',
        component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/oauth/login.vue'),
        /* no children */
      },
  _definePage_default_10
  )
    ],
  },
  {
    path: '/regle',
    /* internal name: 'regle' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'dashboard',
        name: 'regle-dashboard',
        component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/regle/dashboard.vue'),
        /* no children */
      },
  _definePage_default_11
  ),
      {
        path: 'email-templates',
        /* internal name: 'regle-email-templates' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'regle-email-templates',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/regle/email-templates/index.vue'),
            /* no children */
          },
  _definePage_default_12
  ),
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'regle-email-templates-id',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/regle/email-templates/[id].vue'),
            /* no children */
          },
  _definePage_default_13
  )
        ],
      },
      {
        path: 'notification-logs',
        /* internal name: 'regle-notification-logs' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'regle-notification-logs',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/regle/notification-logs/index.vue'),
            /* no children */
          },
  _definePage_default_14
  )
        ],
      },
      {
        path: 'notification-settings',
        /* internal name: 'regle-notification-settings' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'regle-notification-settings',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/regle/notification-settings/index.vue'),
            /* no children */
          },
  _definePage_default_15
  )
        ],
      }
    ],
  },
  {
    path: '/review',
    /* internal name: 'review' */
    /* no component */
    children: [
      {
        path: 'auto-migration',
        /* internal name: 'review-auto-migration' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-auto-migration',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/auto-migration/index.vue'),
            /* no children */
          },
  _definePage_default_16
  )
        ],
      },
      {
        path: 'auto-migration-list',
        /* internal name: 'review-auto-migration-list' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-auto-migration-list',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/auto-migration-list/index.vue'),
            /* no children */
          },
  _definePage_default_17
  )
        ],
      },
      {
        path: 'channels',
        /* internal name: 'review-channels' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-channels',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/channels/index.vue'),
            /* no children */
          },
  _definePage_default_18
  )
        ],
      },
      {
        path: 'client',
        /* internal name: 'review-client' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-client',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/client/index.vue'),
            /* no children */
          },
  _definePage_default_19
  ),
          {
            path: ':id',
            /* internal name: 'review-client-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'review-client-id',
                component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/client/[id]/index.vue'),
                /* no children */
              },
  _definePage_default_20
  ),
  _mergeRouteRecord(
              {
                path: 'edit',
                name: 'review-client-id-edit',
                component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/client/[id]/edit.vue'),
                /* no children */
              },
  _definePage_default_21
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'review-client-create',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/client/create.vue'),
            /* no children */
          },
  _definePage_default_22
  )
        ],
      },
      {
        path: 'client-reports',
        /* internal name: 'review-client-reports' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-client-reports',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/client-reports/index.vue'),
            /* no children */
          },
  _definePage_default_23
  )
        ],
      },
      {
        path: 'crawling-status',
        /* internal name: 'review-crawling-status' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-crawling-status',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/crawling-status/index.vue'),
            /* no children */
          },
  _definePage_default_24
  )
        ],
      },
      {
        path: 'crema-brands',
        /* internal name: 'review-crema-brands' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-crema-brands',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/crema-brands/index.vue'),
            /* no children */
          },
  _definePage_default_25
  )
        ],
      },
      {
        path: 'daily-reports',
        /* internal name: 'review-daily-reports' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-daily-reports',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/daily-reports/index.vue'),
            /* no children */
          },
  _definePage_default_26
  )
        ],
      },
      {
        path: 'data',
        /* internal name: 'review-data' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-data',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/data/index.vue'),
            /* no children */
          },
  _definePage_default_27
  )
        ],
      },
      {
        path: 'download-driver',
        /* internal name: 'review-download-driver' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-download-driver',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/download-driver/index.vue'),
            /* no children */
          },
  _definePage_default_28
  )
        ],
      },
      {
        path: 'error-stats',
        /* internal name: 'review-error-stats' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-error-stats',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/error-stats/index.vue'),
            /* no children */
          },
  _definePage_default_29
  )
        ],
      },
      {
        path: 'estimates',
        /* internal name: 'review-estimates' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-estimates',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/estimates/index.vue'),
            /* no children */
          },
  _definePage_default_30
  ),
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'review-estimates-create',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/estimates/create.vue'),
            /* no children */
          },
  _definePage_default_31
  )
        ],
      },
      {
        path: 'image-size',
        /* internal name: 'review-image-size' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-image-size',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/image-size/index.vue'),
            /* no children */
          },
  _definePage_default_32
  )
        ],
      },
      {
        path: 'mapping-manager',
        /* internal name: 'review-mapping-manager' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-mapping-manager',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/mapping-manager/index.vue'),
            /* no children */
          },
  _definePage_default_33
  )
        ],
      },
      {
        path: 'naver-xls',
        /* internal name: 'review-naver-xls' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-naver-xls',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/naver-xls/index.vue'),
            /* no children */
          },
  _definePage_default_34
  )
        ],
      },
      {
        path: 'non-displayed-items',
        /* internal name: 'review-non-displayed-items' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-non-displayed-items',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/non-displayed-items/index.vue'),
            /* no children */
          },
  _definePage_default_35
  )
        ],
      },
      {
        path: 'report',
        /* internal name: 'review-report' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-report',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/report/index.vue'),
            /* no children */
          },
  _definePage_default_36
  )
        ],
      },
      {
        path: 'scan',
        /* internal name: 'review-scan' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-scan',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/scan/index.vue'),
            /* no children */
          },
  _definePage_default_37
  )
        ],
      },
      {
        path: 'scanner',
        /* internal name: 'review-scanner' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-scanner',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/scanner/index.vue'),
            /* no children */
          },
  _definePage_default_38
  )
        ],
      },
      {
        path: 'tasks',
        /* internal name: 'review-tasks' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-tasks',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/tasks/index.vue'),
            /* no children */
          },
  _definePage_default_39
  )
        ],
      },
      {
        path: 'upload',
        /* internal name: 'review-upload' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-upload',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/upload/index.vue'),
            /* no children */
          },
  _definePage_default_40
  )
        ],
      },
      {
        path: 'upload-driver',
        /* internal name: 'review-upload-driver' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-upload-driver',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/upload-driver/index.vue'),
            /* no children */
          },
  _definePage_default_41
  )
        ],
      },
      {
        path: 'upload-summary',
        /* internal name: 'review-upload-summary' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'review-upload-summary',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/review/upload-summary/index.vue'),
            /* no children */
          },
  _definePage_default_42
  )
        ],
      }
    ],
  },
  {
    path: '/settings',
    /* internal name: 'settings' */
    /* no component */
    children: [
      {
        path: 'mcp-api-keys',
        /* internal name: 'settings-mcp-api-keys' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'settings-mcp-api-keys',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/settings/mcp-api-keys/index.vue'),
            /* no children */
          },
  _definePage_default_43
  )
        ],
      },
      {
        path: 'oauth-clients',
        /* internal name: 'settings-oauth-clients' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'settings-oauth-clients',
            component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/settings/oauth-clients/index.vue'),
            /* no children */
          },
  _definePage_default_44
  )
        ],
      }
    ],
  },
  {
    path: '/utility',
    /* internal name: 'utility' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'utility',
        component: () => import('/home/runner/work/SeoulVenturesGroupware/SeoulVenturesGroupware/frontend/resources/ts/pages/utility/index.vue'),
        /* no children */
      },
  _definePage_default_45
  )
    ],
  }
]
